(function ($) {
  $(document).ready(function ($) {
    if ($("body.index").length) {
      var $brandCarousel = $(".index__brand-carousel .owl-carousel");
      var $brandCarouselNext = $(".index__brand-carousel .carousel-nav-contain > .next");
      var $brandCarouselPrev = $(".index__brand-carousel .carousel-nav-contain > .prev");

      $brandCarousel
        .on("initialized.owl.carousel", function (e) {
          $(this).find(".slide-card").eq(0).addClass("active");
        })
        .owlCarousel({
          autoplay: false,
          items: 1,
          rewind: true,
          nav: false,
          dots: false,
          autoHeight: true,
          responsive: {
            768: { autoWidth: true, autoHeight: false },
          },
        });

      $brandCarouselNext.on("click", function () {
        $brandCarousel.trigger("next.owl.carousel");
      });

      $brandCarouselPrev.on("click", function () {
        $brandCarousel.trigger("prev.owl.carousel");
      });

      $brandCarousel.on("changed.owl.carousel", function (e) {
        $(this).find(".slide-card").removeClass("active");
        $(this).find(".slide-card").eq(e.item.index).addClass("active");
      });

      $(window).on("resize", function () {
        $brandCarousel.find(".owl-stage-outer").width(innerWidth);
      });
    }
  });
})(jQuery);
